import React from 'react'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import './styles/App.scss'
import { persistor, store } from './store'
import moment from 'moment'
import 'moment/locale/ru'
import { ConfigProvider } from 'antd'
import ruRu from 'antd/es/locale/ru_RU'
import { RouterComponent } from '@router/RouterComponent'
import ErrorBoundary from '@pages/ErrorBoundary/ErrorBoundary'
import { useThemeSelector } from '@store/selectors/theme'

moment.locale('ru')

function AppInner() {
  const theme = useThemeSelector()

  return (
    <div id={'App'} className={`App ${theme}`}>
      <ErrorBoundary>
        <ConfigProvider locale={ruRu}>
          <RouterComponent />
        </ConfigProvider>
      </ErrorBoundary>
    </div>
  )
}

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppInner />
      </PersistGate>
    </Provider>
  )
}

export default App
